import { KAActionBucketPageDataLabelValues } from '../collections/KAActionBucketPageDataLabels';

export const COLLECTION_CONTEXT_TYPES = Object.freeze({
  Url: 'url',
  Media: 'media',
  XmlSitemap: 'xmlSitemap',
  Connector: 'connector',
  PlainText: 'plainText',
});

export const ADD_CONTEXT_STEPS = Object.freeze([
  { title: 'Select type' },
  { title: 'Enter details' },
]);

/** URL, media, and plain text pick labels before they are added. Sitemap does not. */
export const ADD_CONTEXT_LABEL_STEPS = Object.freeze([
  { title: 'Select type' },
  { title: 'Enter details' },
  { title: 'Add labels' },
]);

const CONTEXT_TYPES_WITH_LABEL_STEP = new Set([
  COLLECTION_CONTEXT_TYPES.Url,
  COLLECTION_CONTEXT_TYPES.Media,
  COLLECTION_CONTEXT_TYPES.PlainText,
]);

export const contextTypeSupportsAddLabels = type => CONTEXT_TYPES_WITH_LABEL_STEP.has(type);

export const getDefaultAddContextLabels = () => [KAActionBucketPageDataLabelValues.KnowledgeAgent];

export const CONTEXT_TYPE_OPTIONS = Object.freeze([
  {
    value: COLLECTION_CONTEXT_TYPES.Url,
    title: 'URLs',
    description: 'Add individual page URLs for the collection to crawl.',
    icon: 'LinkOutlined',
    iconSource: 'custom',
    isEnabled: true,
  },
  {
    value: COLLECTION_CONTEXT_TYPES.Media,
    title: 'File upload',
    description: 'Upload PDF, DOCX, CSV, and other document files.',
    icon: 'UploadOutlined',
    iconSource: 'custom',
    isEnabled: true,
  },
  {
    value: COLLECTION_CONTEXT_TYPES.XmlSitemap,
    title: 'XML sitemap',
    description: 'Provide a sitemap URL to crawl multiple pages at once.',
    icon: 'CodeOutlined',
    iconSource: 'custom',
    isEnabled: true,
  },
  {
    value: COLLECTION_CONTEXT_TYPES.PlainText,
    title: 'Plain text',
    description: 'Paste or type manual text content directly.',
    icon: 'FileTextOutlined',
    iconSource: 'antd',
    isEnabled: true,
  },
  {
    value: COLLECTION_CONTEXT_TYPES.Connector,
    title: 'Connectors',
    description: 'Connect to platforms like Swapcard, Cvent, and more.',
    icon: 'ApartmentOutlined',
    iconSource: 'antd',
    isEnabled: false,
  },
]);
